import { CustomerType } from "../../../../graphql/generated";

export const addressTypesLabels = {
  [CustomerType.Contact]: "Address",
  [CustomerType.Delivery]: "Delivery Address",
  [CustomerType.Invoice]: "Invoice Address",
  [CustomerType.Private]: "Private Address",
  [CustomerType.Other]: "Other Address",
};
